import { FabrixNotice } from "@nt-portal/server-sdk";
import { DashboardButton } from "fabrix/components/dashboard-button";
import { useCurrentUser, useHasRoles, useIcon, useUserPermissions, useUserProfile, useUserRoles } from "fabrix/hooks";
import { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { FabrixIcon, translate } from "../../common";
import { useBreadcrumbs } from "../../hooks/use-breadcrumbs";
import { useTabTitle } from "../../hooks/use-tab-title";
import { MessageType } from "../../redux/message-box.slice";
import { ModulesState } from "../../redux/module-slice";
import { AppState } from "../../redux/store";
import { ClientNoticeService } from "../../services";
import { ModuleInfo } from "../../types";
import "./index.scss";
import UserProfileInfo from "../../components/user-profile/user-profile-info";
import NotificationView from "../../components/notifications-view";



export default function Home() {
  const icon = useIcon();
  const navigate = useNavigate();
  const location = useLocation();
  const user = useCurrentUser();
  const [userProfile, updateProfile] = useUserProfile();
  const permissions = useUserPermissions();
  const roles = useUserRoles();
  const [, hasRoles] = useHasRoles();
  const [setBreadcrumbs] = useBreadcrumbs();
  const setTitle = useTabTitle();
  const _moduleState = useSelector<AppState>((state) => state.modules) as ModulesState;
  const [_msgClassName, setMsgClassName] = useState<string>("");
  const [_topMessage, setTopMessage] = useState<string>("");
  const messageState = location.state;
  const [_imageWidth, setImageWidth] = useState<string>("");
  const [_imageHeight, setImageHeight] = useState<string>("");
  const [_notices, setNotices] = useState<FabrixNotice[]>([])
  const _showRoleRequest = useMemo(() => {
    let keys = Object.keys(permissions);
    return keys.length === 0 || (!userProfile?.department);
  }, [permissions, userProfile])

  // useEffect(() => {
  //   console.log(user);
  //   console.log(permissions);
  //   console.log(roles);
  // }, [user, permissions, roles]);

  const visibleModules = useMemo<ModuleInfo[]>(() => {
    const userModules = _moduleState.userModules;

    return _moduleState.modules
      .filter((module) => {
        if (module.type === "dynamic") {
          return userModules.includes(module.id);
        }
        if (module.type === "system") {
          return !module.roles || module.roles.length === 0 || hasRoles(module.roles);
        }
        return false;
      })
      .map((module) => ({ ...module, label: translate(module.label) }))
      .sort((first, second) => first.label.localeCompare(second.label));
  }, [_moduleState.modules, _moduleState.userModules, hasRoles]);

  useEffect(() => {
    setTopMessage(messageState?.message ?? "");
    if (messageState?.messageType) {
      switch (messageState.messageType) {
        case MessageType.Info:
          setMsgClassName("fbx-home-message-info");
          break;
        case MessageType.Warning:
          setMsgClassName("fbx-home-message-warning");
          break;
        case MessageType.Error:
          setMsgClassName("fbx-home-message-error");
          break;
        case MessageType.Success:
          setMsgClassName("fbx-home-message-success");
          break;
      }
    }
  }, [messageState]);


  const loadNotices = () => {
    let service = new ClientNoticeService();
    service.show().then(result => {
      setNotices(result.data)
    })
  }

  const handleNavClick = (module: ModuleInfo) => {
    setTitle(module.label);
    navigate(module.path);
    setBreadcrumbs([]);
  };

  useEffect(() => {
    setTitle(translate("HOME"));
    loadNotices();
  }, []);



  return (
    <div className="fbx-home-page fbx-full-height">
      <div className="nt-left">

      </div>

      <div className="nt-nav">
        <div style={{ display: _topMessage === "" ? "none" : "block" }} className={`fbx-home-message ${_msgClassName}`}>
          <span>{_topMessage}</span>
          <div onClick={() => setTopMessage("")} className={icon(FabrixIcon.cancel) + " fbx-home-message-close"}></div>
        </div>
        <div style={{ display: _notices.length === 0 ? "none" : "block" }} className={`fbx-system-message`}>
          <ul>
            {
              _notices.map(m => (
                <li className={`fbx-system-message-${m.type}`}>{m.notice}</li>
              ))
            }</ul>

        </div>
        <div className="flex flex-wrap justify-content-center fbx-dashboard" >
          {visibleModules.map((m) => {

            return <DashboardButton key={m.id} id={m.name} className="flex align-items-center justify-content-center  fbx-icon-button-md m-2" onClick={() => handleNavClick(m)} caption={m.label} icon={m.icon} />;
          })}
        </div>

        <div className="flex justify-content-center" >
          {
            _showRoleRequest && (<div className="" ><UserProfileInfo mode="user" showSave={true} /></div>)
          }
        </div>

        {/** This part is ready but the sending group notifications is not implemented yet */}
        {/* <div className="flex flex-column home-notifications" >
          <div className="home-notifications-header flex justify-content-center"><p>{translate("UNREAD_NOTIFICATIONS")}</p></div>
          <NotificationView autoMarkAsRead={false} mode={"compact"} read={false} dataViewStyle={{ width: "calc(100% - 40px)", height: "calc(100% - 125px)" }} />
        </div> */}

      </div>



    </div>
  );
}
